export function loginDestination(value) {
  return typeof value === 'string' && /^\/tasks\/[1-9]\d*(?:\?comment=[1-9]\d*)?(?:#comments)?$/.test(value) ? value : '/main'
}
